import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../../env";

const AddRoomTariff = ({ show, onClose, onSubmit }) => {
  const [hotels, setHotels] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [roomDetails, setRoomDetails] = useState([]);
  const [showRoomDetails, setShowRoomDetails] = useState(false);

  const [form, setForm] = useState({
    P_INTHOTELID: "",
    P_INTROOMCONFIGID: "",
    P_VCHNOOFROOMS: "",
    P_DCMPRICEPERDAY: "",
    P_DCMEXTRAPERSONRATE: "",
    P_DTMEFFECTDATE: "",
    P_DTMEFFECTTILL: "",
    P_INTCREATEDBY: 1,
    P_VCHROOMDETAILS: "",
  });

  useEffect(() => {
    if (show) {
      resetForm();
    }
  }, [show]);

  useEffect(() => {
    fetchHotels();
  }, []);

  useEffect(() => {
    if (form.P_INTHOTELID) {
      fetchRoomTypes(form.P_INTHOTELID);
    }

    setForm((prev) => ({
      ...prev,
      P_INTROOMCONFIGID: "",
      P_VCHNOOFROOMS: "",
      P_DCMPRICEPERDAY: "",
      P_DCMEXTRAPERSONRATE: "",
      P_DTMEFFECTDATE: "",
      P_DTMEFFECTTILL: "",
    }));
    setShowRoomDetails(false);
    setRoomDetails([]);
  }, [form.P_INTHOTELID]);

  useEffect(() => {
    if (form.P_INTHOTELID && form.P_INTROOMCONFIGID) {
      fetchExistingTariff(form.P_INTHOTELID, form.P_INTROOMCONFIGID);
    }
  }, [form.P_INTROOMCONFIGID]);

  const resetForm = () => {
    setForm({
      P_INTHOTELID: "",
      P_INTROOMCONFIGID: "",
      P_VCHNOOFROOMS: "",
      P_DCMPRICEPERDAY: "",
      P_DCMEXTRAPERSONRATE: "",
      P_DTMEFFECTDATE: "",
      P_DTMEFFECTTILL: "",
      P_INTCREATEDBY: 1,
      P_VCHROOMDETAILS: "",
    });
    setRoomTypes([]);
    setRoomDetails([]);
    setShowRoomDetails(false);
  };

  const fetchHotels = async () => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_URL}api/room-tariff/get-hotels`
      );
      const formatted = res.data.data.map((h) => ({
        value: h.PropertyID,
        label: h.UnitName,
      }));
      setHotels(formatted);
    } catch (err) {
      console.error("Failed to fetch hotels:", err);
    }
  };

  const fetchRoomTypes = async (hotelId) => {
    try {
      const res = await axios.post(
        `${REACT_APP_API_URL}api/room-tariff/get-room-types`,
        {
          P_CHRACTION: "RT",
          P_INTPROPERTYID: hotelId,
        }
      );
      setRoomTypes(res.data.data || []);
    } catch (err) {
      console.error("Failed to fetch room types:", err);
    }
  };

  const fetchExistingTariff = async (hotelId, roomConfigId) => {
    try {
      const res = await axios.post(
        `${REACT_APP_API_URL}api/room-tariff/get-existing-tariff`,
        {
          P_INTHOTELID: hotelId,
          P_INTROOMCONFIGID: roomConfigId,
        }
      );

      if (res.data.success && res.data.data.length > 0) {
        const data = res.data.data[0];
        setForm((prev) => ({
          ...prev,
          P_VCHNOOFROOMS: data.NoOfRoomsAvailable || "",
          P_DCMPRICEPERDAY: data.PricePerDay || "",
          P_DCMEXTRAPERSONRATE: data.ExtraPersonRate || "",
          P_DTMEFFECTDATE: data.EffectiveDate?.split("T")[0] || "",
          P_DTMEFFECTTILL: data.EffectiveTill?.split("T")[0] || "",
        }));
      }
    } catch (err) {
      console.error("Error fetching existing tariff:", err);
    }
  };

  const fetchRoomDetails = async () => {
    if (!form.P_INTHOTELID || !form.P_INTROOMCONFIGID) return;

    try {
      const res = await axios.post(
        `${REACT_APP_API_URL}api/room-tariff/get-room-details`,
        {
          P_INTPROPERTYID: form.P_INTHOTELID,
          P_INTROOMCONFIGID: form.P_INTROOMCONFIGID,
        }
      );

      if (res.data.success) {
        setRoomDetails(res.data.data);
        setShowRoomDetails(true);
        setForm((prev) => ({
          ...prev,
          P_VCHNOOFROOMS: res.data.data.length.toString(),
        }));
      } else {
        setRoomDetails([]);
        setShowRoomDetails(false);
      }
    } catch (error) {
      console.error("Failed to fetch room details:", error);
      setRoomDetails([]);
      setShowRoomDetails(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const xmlRoomDetails =
        `<ArrayOfHotelTariffConfig>` +
        roomDetails
          .map(
            (r) => `
          <HotelTariffConfig>
            <RoomID>${r.RoomID}</RoomID>
            <RoomNo>${r.RoomNo}</RoomNo>
          </HotelTariffConfig>
        `
          )
          .join("") +
        `</ArrayOfHotelTariffConfig>`;

      const payload = {
        ...form,
        P_DCMPRICEPERDAY: form.P_DCMPRICEPERDAY
          ? parseFloat(form.P_DCMPRICEPERDAY)
          : 0,
        P_DCMEXTRAPERSONRATE: form.P_DCMEXTRAPERSONRATE
          ? parseFloat(form.P_DCMEXTRAPERSONRATE)
          : 0,
        P_VCHROOMDETAILS: xmlRoomDetails,
      };

      const res = await axios.post(
        `${REACT_APP_API_URL}api/room-tariff/add-tariff`,
        payload
      );
      alert(res.data.message || "Tariff saved!");
      onClose();
      onSubmit();
    } catch (err) {
      console.error(err);
      alert("Failed to save tariff.");
    }
  };
  const handleClose = () => {
    resetForm();
    onClose(); 
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add Room Tariff</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Hotel Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              name="P_INTHOTELID"
              value={form.P_INTHOTELID}
              onChange={handleChange}
            >
              <option value="">-- Select Hotel --</option>
              {hotels.map((h) => (
                <option key={h.value} value={h.value}>
                  {h.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Room Type <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              name="P_INTROOMCONFIGID"
              value={form.P_INTROOMCONFIGID}
              onChange={handleChange}
            >
              <option value="">-- Select Room Type --</option>
              {roomTypes.map((r) => (
                <option key={r.HotelRoomConfigID} value={r.HotelRoomConfigID}>
                  {r.HotelRoomConfigType}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              No. of Rooms Available <span className="text-danger">*</span>
            </Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                name="P_VCHNOOFROOMS"
                value={form.P_VCHNOOFROOMS}
                onChange={handleChange}
              />
              {/* <Button
                className="ms-2"
                variant="dark"
                size="sm"
                onClick={fetchRoomDetails}
                disabled={!form.P_INTHOTELID || !form.P_INTROOMCONFIGID}
              >
                + Add Room Details
              </Button> */}
            </div>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Price Per Day (₹) <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="P_DCMPRICEPERDAY"
              value={form.P_DCMPRICEPERDAY}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Extra Person Rate (₹) <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="P_DCMEXTRAPERSONRATE"
              value={form.P_DCMEXTRAPERSONRATE}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Effective Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              name="P_DTMEFFECTDATE"
              value={form.P_DTMEFFECTDATE}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Effective Till Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              name="P_DTMEFFECTTILL"
              value={form.P_DTMEFFECTTILL}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>

        {showRoomDetails && (
          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>SL No</th>
                <th>Room Details</th>
              </tr>
            </thead>
            <tbody>
              {roomDetails.map((room, idx) => (
                <tr key={idx}>
                  <td>{room.serialNo}</td>
                  <td>{room.roomNo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleSubmit}
          disabled={!form.P_DTMEFFECTDATE || !form.P_DTMEFFECTTILL}
        >
          Save Tariff
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddRoomTariff;
